<template>
  <TWModal
    :title="$t('bulkSend.steps.usage.overagesModalTitle')"
    :loading="loading"
    :show="show"
    @close="$emit('close')"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <p>{{ $t('bulkSend.steps.usage.overagesModalInfo') }}</p>
      <div class="flex gap-base items-center">
        <VCheckbox
          type="checkbox"
          subtype="toggle"
          :checked="overageSetting"
          @input="toggleOverages"
          data-ec="bulk_send_toggle_overages_modal"
          data-et="enable_overages_toggle" />
        <b>{{ overageStatusDisplay }}</b>
      </div>
    </template>
    <template v-slot:controls>
      <BaseButton
        class="mr-base"
        size="small"
        variant="invisible"
        data-ec="bulk_send_toggle_overages_modal"
        data-et="cancel_button"
        @click.native="$emit('close')">
        <span>{{ $t('functional.cancel') }}</span>
      </BaseButton>
      <BaseButton
        size="small"
        data-ec="bulk_send_toggle_overages_modal"
        data-et="save_button"
        @click.native="handleSaveOverageSetting">
        <span>{{ $t('functional.save') }}</span>
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';

export default {
  name: 'EnableOveragesModal.vue',
  components: {
    TWModal,
    BaseButton,
    VCheckbox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    initialOverageSetting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      overageSetting: this.initialOverageSetting,
    };
  },
  methods: {
    toggleOverages() {
      this.overageSetting = !this.overageSetting;
    },
    async handleSaveOverageSetting() {
      this.loading = true;
      await this.$store.dispatch('company/UPDATE', { billing_overage: this.overageSetting });
      this.$emit('overageSettingUpdated');
      this.loading = false;
      this.$emit('close');
    },
  },
  computed: {
    overageStatusDisplay() {
      return this.overageSetting ? this.$t('functional.enabled') : this.$t('functional.disabled');
    },
  },
};

</script>
